<template>
  <sweet-modal ref="imagens" width="70vw" hide-close-button blocking>
    <div class="upload-area">
      <file-upload
        @success="getImages"
        :url="`${apiUrl}/api/external_images/upload`"
        :headers="headers"
      ></file-upload>
    </div>

    <div
      v-for="(element, index) in images"
      :key="index"
      :id="element.id"
      class="image-item"
      @click="selectImage(element)"
    >
      <img :src="element" :alt="element" />
      <span class="image-name">{{element.name}}</span>
    </div>

    <button slot="button" class="btn btn-outline-info" @click="close">Cancel</button>
    <button slot="button" class="btn btn-outline-success" @click="save">Select</button>
  </sweet-modal>
</template>

<script>
import {
  getImages,
  uploadImage
} from './../../../js/services/editor/externalImage';
import { SweetModal } from 'sweet-modal-vue';
import FileUpload from 'v-file-upload';

export default {
  name: 'ModalUploadImage',
  props: ['show'],
  components: { SweetModal, FileUpload },
  data() {
    return {
      images: null,
      imageSelected: null,
      headers: {
        authorization: 'Bearer ' + localStorage.getItem('token')
      }
    };
  },

  watch: {
    show: function(value) {
      if (value) {
        this.open();
      } else this.$refs.imagens.close();
    }
  },

  computed: {
    apiUrl() {
      return typeof process.env.API_URL !== 'undefined' ? process.env.API_URL : 'https://cheetah-api.builderall.com';
    }
  },

  methods: {
    getImages() {
      this.$emit('getImages');
    },
    selectImage(image) {
      let elements = document.getElementsByClassName('focused');
      [].forEach.call(elements, function(el) {
        el.classList.remove('focused');
      });
      this.imageSelected = image;
      document.getElementById(image.id).classList.add('focused');

      this.$emit('selectImage', image);
    },
    close() {
      this.$emit('close');
    },
    save() {
      this.$emit('save', this.imageSelected);
    },
    open() {
      let body = document.getElementsByTagName('body')[0];

      body.classList.add('loading');

      getImages().then(res => {
        let elements = document.querySelectorAll('.widget-focused, .focused');

        [].forEach.call(elements, function(el) {
          el.classList.remove('widget-focused');
          el.classList.remove('focused');
        });

        this.images = res.data.images.files;
        this.$refs.imagens.open();

        body.classList.remove('loading');
      });
    }
  }
};
</script>

<style lang="scss" scoped>

  .form-group {
    overflow: hidden;
  }

  .image-item {
    width: 140px;
    height: 70px;
    display: inline-block;
    cursor: pointer;
    text-align: center;
  }

  .image-item.focused {
    outline: 2px solid blue;
  }

  .image-item img {
    width: 100px;
    height: 50px;
  }

  .image-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
  }

  .sweet-modal {

    .sweet-content {
      max-height: 70vh !important;
      overflow: auto;
      text-align: left;
    }

    .btn {
      cursor: pointer;
      margin-left: 5px;
    }
  }

  .upload-area {
    text-align: right;
    padding-bottom: 20px;
    height: 70px;

    .file-upload .input-wrapper {
      height: 50px;
      width: 15%;
      float: right;
    }

    .file-upload-icon {
      display: none !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/dashboard/components/ModalUploadImage.vue